export default __webpack_public_path__ + "static/media/pixellab--graphic-design--04--1200x900.1ea2ef47.jpg";